<template>
  <div class=" employee-tab leave-attendance-dashboard">

    <div class="col-md-10 col-sm-12 pl-0" >
      <h4 class="atlhr-dashboard-title mt-10">Leave & Attendance<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Leave & Attendance / Off Day Management</span></h4>
    </div>

    <b-overlay :show="showoverlay">

      <div class="row mt-4">
        <div class="col mb-3">
          <b-card class="stat-card shadow-sm" body-class="py-3 px-3">
            <div class="d-flex align-items-center">
              <div class="stat-icon bg-soft-primary text-primary mr-3">
                <b-icon icon="people" font-scale="2"></b-icon>
              </div>
              <div>
                <div class="h4 mb-0 font-weight-bold">{{ custom_list.length }}</div>
                <div class="text-muted small">Total Employees</div>
              </div>
            </div>
          </b-card>
        </div>

        <div class="col mb-3">
          <b-card class="stat-card shadow-sm" body-class="py-3 px-3">
            <div class="d-flex align-items-center">
              <div class="stat-icon bg-soft-warning text-warning mr-3">
                <b-icon icon="person" font-scale="2"></b-icon>
              </div>
              <div>
                <div class="h4 mb-0 font-weight-bold">{{ totalWithPattern }}</div>
                <div class="text-muted small">With Off Days</div>
              </div>
            </div>
          </b-card>
        </div>

        <div class="col mb-3">
          <b-card class="stat-card shadow-sm" body-class="py-3 px-3">
            <div class="d-flex align-items-center">
              <div class="stat-icon bg-soft-primary text-primary mr-3">
                <b-icon icon="arrow-repeat" font-scale="2"></b-icon>
              </div>
              <div>
                <div class="h4 mb-0 font-weight-bold">{{ weeklyPatternCount }}</div>
                <div class="text-muted small">Weekly Patterns</div>
              </div>
            </div>
          </b-card>
        </div>
      </div>

      <div class="w-100 d-flex justify-content-center align-items-center">
        <div class="w-75">
          <b-alert variant="warning" show class="d-flex justify-content-center align-items-center mb-0">
            <b-icon icon="exclamation-triangle-fill" variant="danger" font-scale="1.5" class="mr-2"></b-icon>
            <span><strong>Disclaimer:</strong> Updating off days will only affect dates that match the selected off-day pattern within the chosen date range. Existing shift and attendance data on those off-day pattern dates may be overwritten and treated as off days.</span>
          </b-alert>
        </div>
      </div>

        <div class="border-0 no-shadow d-flex flex-column" id="off-day-assign">
          <div class="d-flex justify-content-end">
            <b-button variant="primary" @click="assignOffDayModal" v-b-tooltip.hover.top="'Select employees and assign their weekly off days.'" style="transform: translate(-360px, 54px);">Assign Off Day</b-button>
          </div>
          <common-list :checkbox="1" :is_action="1" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list"
                       :all_employee="'no'" :default_column="default_column" :primary_key="'employee_id'" v-on:childToParent="listReturn"></common-list>
        </div>

    </b-overlay>


    <b-modal id="bv-modal-assign-off-day" title="Assign Off Day" :size="modalSize" hide-footer>
      <b-alert variant="warning" show="" class="d-flex justify-content-center align-items-center mb-0">
          <b-icon icon="exclamation-triangle-fill" variant="danger" font-scale="1.5" class="mr-2"></b-icon>
          <span v-if="fdata.assign_mode == 'monthly'"><strong>Disclaimer:</strong> Applies the selected off-day pattern from tomorrow to end of leave year.</span>
          <span v-else><strong>Disclaimer:</strong> Applies the selected off-day pattern only within the selected date range.</span>
      </b-alert>
      
      <b-form @submit.stop.prevent="saveAssignments">

        <b-form-group label="Assignment Mode" label-for="assign-mode-id" class="required-field">
          <b-form-select id="assign-mode-id" v-model="fdata.assign_mode" :options="assignModeOptions"></b-form-select>
        </b-form-group>

        <div v-if="fdata.assign_mode === 'monthly'">
          <b-form-group label="" label-for="break-id">
            <b-form-checkbox switch id="break-id" name="break_id" v-model="fdata.break" :value="1" :unchecked-value="0">Get a year breakdown</b-form-checkbox>
          </b-form-group>

          <div v-if="fdata.break == 0">
            <b-form-group label="Off Day Pattern" label-for="pattern-id" class="required-field">
              <b-form-select id="pattern-id" name="pattern_id" v-model="fdata.pattern_id" :options="patternOptions" v-validate="'required'" data-vv-as="Off Day Pattern"
                             :state="validateState('pattern_id')" aria-describedby="pattern-id-feedback"/>
              <b-form-invalid-feedback id="pattern-id-feedback" v-if="veeErrors.has('pattern_id')">{{ veeErrors.first('pattern_id') }}</b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div v-else class="ibox p-2">
            <h6 class="text-primary mb-2">Assign Pattern for Each Month</h6>
            <div class="row">
              <div class="col-md-6 col-lg-4 mb-2" v-for="m in monthOptions" :key="m.value">
                <b-form-group :label="m.text" :label-for="'pattern-' + m.value" class="mb-1">
                  <b-form-select :id="'pattern-' + m.value" v-model="fdata.patterns[m.value]" :options="patternOptions" :name="'pattern_' + m.value"
                                 :data-vv-as="m.text + ' Pattern'" :state="veeErrors.has('pattern_' + m.value) ? false : (fdata.patterns[m.value] ? true : null)" :aria-describedby="'pattern-feedback-' + m.value"/>
                  <b-form-invalid-feedback :id="'pattern-feedback-' + m.value" v-if="veeErrors.has('pattern_' + m.value)">{{ veeErrors.first('pattern_' + m.value) }}</b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="fdata.assign_mode === 'daterange'">
          <div class="row">
            <div class="col-md-6">
              <b-form-group id="application_date-group" label="From Date" label-for="from-date">
                <b-input-group class="mb-3">
                  <b-form-input @input="getQueue" id="from-date" name="from-date" v-model="fdata.from_date" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('from-date')" aria-describedby="from-date-feedback" data-vv-as="Date"/>
                  <b-input-group-append>
                    <b-form-datepicker id="day_one" button-only right locale="en-US" v-model="fdata.from_date" />
                  </b-input-group-append>
                  <b-form-invalid-feedback id="from-date-feedback"> {{ veeErrors.first('from-date') }} </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="To Date" label-for="to-date-id">
                <b-input-group class="mb-3">
                  <b-form-input id="to-date-id" name="to-date" v-model="fdata.to_date" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('to-date')" aria-describedby="to-date-feedback" data-vv-as="To Date" />

                  <b-input-group-append>
                    <b-form-datepicker id="day_two" button-only right locale="en-US" v-model="fdata.to_date" :min="fdata.from_date" />
                  </b-input-group-append>

                  <b-form-invalid-feedback id="to-date-feedback"> {{ veeErrors.first('to-date') }} </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
          <b-form-group label="Off Day Pattern" label-for="range-pattern-id" class="required-field">
            <b-form-select id="range-pattern-id" name="range_pattern_id" v-model="fdata.range_pattern_id" :options="patternOptions" v-validate="'required'" data-vv-as="Off Day Pattern" :state="validateState('range_pattern_id')" aria-describedby="range-pattern-feedback"/>
            <b-form-invalid-feedback id="range-pattern-feedback" v-if="veeErrors.has('range_pattern_id')">{{ veeErrors.first('range_pattern_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </div>

        <div class="mt-3">
          <b-button type="submit" variant="primary" block>Assign Off Day(s)</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="bv-modal-offday-history" title="Off Day History" size="lg" hide-footer>

      <div class="table-responsive employee-table-wrapper">
        <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
          <thead class="table-head">
          <tr>
            <th>SL</th>
            <th v-for="(column, i) in columns" :key="i">{{ column.label }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(s, index) in off_day_history" :key="s.id" class="hover-bg table-row border-bottom mx-2">
            <td>{{ index + 1 }}</td>
            <td>{{ s.template.name }}</td>
            <td> <span v-for="d in s.template.pattern_labels" :key="d" size="md" class="mr-1 mb-1  px-2 py-1 bg-info rounded">{{ d }}</span></td>
            <td>{{ s.period_start }}</td>
            <td>{{ s.period_end }}</td>
          </tr>

          <tr>
            <td class="text-center" colspan="6" v-if="off_day_history.length == 0">No off-day records found.</td>
          </tr>
          </tbody>
        </table>

      </div>

    </b-modal>
  </div>
</template>

<script>

export default {
  data() {
    return {
      employees: [],
      patterns: [],
      patternOptions: [],
      custom_list: [],
      selected:[],
      list_key:0,
      company_options: [],
      showoverlay: false,
      default_column:['name','employee_code','email','department','jobposition', 'branch'],
      appended_column: [
        { value: "off_day", text: "Off Day", type: "text" },
      ],
      off_day_history:[],
      columns: [
        { key: 'template.name', label: 'Template' },
        { key: 'template.pattern_labels', label: 'Pattern' },
        { key: 'period_start', label: 'Start Date' },
        { key: 'period_end', label: 'End Date' },
      ],

      fdata: {
        assign_mode: 'monthly',
        break: 0,
        pattern_id: null,
        patterns: {},
        from_date: null,
        to_date: null,
        range_pattern_id: null,
      },
      start_month: 1,
      assignModeOptions: [
        { value: 'monthly', text: 'Assign Monthly' },
        { value: 'daterange', text: 'Assign With Date Range' },
      ],
      monthOptions:[],
      months: [
        { value: 1, text: "January" }, { value: 2, text: "February" },
        { value: 3, text: "March" }, { value: 4, text: "April" },
        { value: 5, text: "May" }, { value: 6, text: "June" },
        { value: 7, text: "July" }, { value: 8, text: "August" },
        { value: 9, text: "September"}, { value: 10, text: "October" },
        { value: 11, text: "November"}, { value: 12, text: "December" },
      ],
    };
  },
  computed: {
    totalWithPattern() {
      const ids = this.custom_list.filter((emp) => emp.off_day);
      return ids.length;
    },
    weeklyPatternCount() {
      return this.patterns.length;
    },
    modalSize() {
      if (this.fdata.assign_mode === 'daterange') return 'md';
      return this.fdata.break == 1 ? 'lg' : 'md';
    },
  },
  watch: {
    'fdata.break'(v) {
      if (v == 1) {
        this.initPatterns();
        this.applySelectedPatternToRemainingMonths();
      }
    },
    'fdata.pattern_id'(val) {
      this.applySelectedPatternToRemainingMonths();
    },
  },
  methods: {
    isPastMonth(month, year) {
      const now = new Date();
      const currentMonth = now.getMonth() + 1;
      const currentYear = now.getFullYear();
      const y = year || currentYear;
      return (y < currentYear) || (y === currentYear && month < currentMonth);
    },
    initPatterns() {
      if (!this.fdata.patterns) this.$set(this.fdata, 'patterns', {});
      for (let m = 1; m <= 12; m++) {
        if (!(m in this.fdata.patterns)) this.$set(this.fdata.patterns, m, null);
      }
    },

    applySelectedPatternToRemainingMonths() {
      const pid = this.fdata.pattern_id;
      if (!pid) return;

      if (!this.fdata.patterns) this.$set(this.fdata, 'patterns', {});
      this.monthOptions.forEach(m => {
        this.$set(this.fdata.patterns, m.value, pid);
      });
    },
    listReturn(data){
      if(data.selected.length > 0)
      {
        this.selected = data.selected;
      }
      else
      {
        this.selected = [];
        if(data.employee_id > 0)
        {
          if(data.action_id == 1) {
            this.showOffDayHistory(data.employee_id);
          }
          else {

          }
        }

      }
    },
    showOffDayHistory(employee_id){
      axios.get(this.$api_url + '/leave-attendance/employees/off-days/' + employee_id).then(res => {
            this.off_day_history = res.data;
            this.$bvModal.show('bv-modal-offday-history');
            this.list_key++;
          }).catch((e) => {
            this.serverError(e);
          });
    },
    getEmployees() {
      this.showoverlay = true;
      axios.get(this.$api_url + '/leave-attendance/employees/list', {
        params: {
          fields:'offday'
        }
      }).then(res => {
        let tmp_employees = res.data.employee_data;
        this.list_key++;
        if(tmp_employees.length > 0 )
        {
          tmp_employees.forEach(element => {
            if(element.employee_id > 0)
            {
              let dop = [];
              dop = dop.concat([{ label: 'Show Off Day History' , value: 1 }]);
              element.actions = dop;
            }
          });

          this.custom_list = tmp_employees;

        }

        this.company_options = res.data.options;
        this.showoverlay = false;
      }).catch(e=>{
        this.serverError(e);
      });
    },

    resetForm(){
      this.fdata = {
        assign_mode: 'monthly',
        pattern_id: null,
        break: 0,
        patterns: {},
        from_date: null,
        to_date: null,
        range_pattern_id: null,
      };
    },

    assignOffDayModal(){
      this.resetForm();
      if(this.selected.length == 0){
        this.$bvToast.toast("Please select employee(s) first",{
          variant:'danger',
          solid: true,
          title: 'Failed',
        });
        return;
      }
      this.$bvModal.show('bv-modal-assign-off-day');
    },

    getPatterns() {
      axios.get(this.$api_url + '/leave-attendance/offday-mapping').then(res => {
        this.patternOptions = [];
        this.patterns = res.data.patterns;
        this.patternOptions = this.patterns.map(p => {
          let pt = JSON.parse(p.pattern);
          let ptt = pt.map(el => this.dayLabel(el));
          return {
            text: `${p.name} (${ptt.join(', ')})`,
            value: p.id
          }
        });
      }).catch(e=>{
        this.serverError(e);
      });
    },

    dayLabel(val) {
      const map = { '0': 'Sun', '1': 'Mon', '2': 'Tue', '3': 'Wed', '4': 'Thu', '5': 'Fri', '6': 'Sat' };
      const key = String(val);
      return map[key];
    },

    validateState(ref) {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    saveAssignments() {
      if (!this.patternOptions.length) return;

      const performSave = () => {
        const formData = new FormData();

        if (this.fdata.assign_mode == 'monthly') {
          let mappings = {};

          this.monthOptions.forEach(m => {
            const pid = this.fdata.patterns[m.value];
            if (pid) {
              mappings[m.value] = pid;
            }
          });
          formData.append('mapping', JSON.stringify(mappings));
        }
        else if (this.fdata.assign_mode == 'daterange') {
          const fromDate = this.fdata.from_date;
          const toDate   = this.fdata.to_date;
          const pid      = this.fdata.range_pattern_id;

          // Validation
          if (!fromDate || !toDate) {
            this.$bvToast.toast('Please select both From Date and To Date.', { variant: 'danger', solid: true });
            return;
          }
          if (!pid) {
            this.$bvToast.toast('Please select an Off Day Pattern.', { variant: 'danger', solid: true });
            return;
          }
          if (fromDate > toDate) {
            this.$bvToast.toast('From Date must be earlier than or equal to To Date.', { variant: 'danger', solid: true });
            return;
          }

          formData.append('pattern_id', pid);
          formData.append('from_date', this.fdata.from_date);
          formData.append('to_date', this.fdata.to_date);
        }

        formData.append('assign_mode', this.fdata.assign_mode);
        formData.append('employee_ids', JSON.stringify(this.selected));

        this.showoverlay = true;
        axios.post(this.$api_url + '/leave-attendance/offday-mapping/save', formData).then(res => {
          this.resetForm();
          this.list_key++;
          this.$bvModal.hide('bv-modal-assign-off-day');
          this.$bvToast.toast(res.data.message, { variant: 'success', solid: true , title: 'Success'});
          this.selected = [];
          this.getEmployees();
          this.showoverlay = false;
        }).catch(e => {
          this.showoverlay = false;
          this.serverError(e);
        });
      };

      if ((this.fdata.assign_mode == 'monthly' && this.fdata.break == 0) || this.fdata.assign_mode == 'daterange') {
        this.$validator.validateAll().then(result => {
          if (result) {
            performSave();
          }
        });
      } else {
        performSave();
      }
    },

    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.start_month = response.data.start_month;
        }
        this.updateMonthOptions();

      }.bind(this));

    },

    updateMonthOptions() {
      const now = new Date();
      const currentMonth = now.getMonth() + 1;
      const currentYear = now.getFullYear();

      let leaveYearStartYear = currentYear;
      const startMonth = parseInt(this.start_month || 1);
      
      if (startMonth !== 1) {
        const endMonth = startMonth - 1;
        if (currentMonth <= endMonth) {
          leaveYearStartYear = currentYear - 1;
        }
      }

      const options = [];
      for (let i = 0; i < 12; i++) {
        const index = startMonth - 1 + i;
        const monthVal = (index % 12) + 1;
        const yearVal = index < 12 ? leaveYearStartYear : leaveYearStartYear + 1;
        const isPastVal = (yearVal < currentYear) || (yearVal === currentYear && monthVal < currentMonth);
        
        const monthObj = this.months.find(m => m.value === monthVal);
        options.push({
          value: monthVal,
          text: `${monthObj.text} ${yearVal}`,
          year: yearVal,
          isPast: isPastVal
        });
      }

      this.monthOptions = options.filter(o => !o.isPast);
    },

  },
  created() {
    this.updateMonthOptions();
    this.getCompanyLeaveSettings();
    this.getEmployees();
    this.getPatterns();
  }
};
</script>
